import { render, staticRenderFns } from "./PartnerPrivacyUSA.vue?vue&type=template&id=b043358c&scoped=true"
import script from "./PartnerPrivacyUSA.vue?vue&type=script&lang=js"
export * from "./PartnerPrivacyUSA.vue?vue&type=script&lang=js"
import style0 from "./PartnerPrivacyUSA.vue?vue&type=style&index=0&id=b043358c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043358c",
  null
  
)

export default component.exports